import { Box } from "@mui/material";
import { SimpleTable } from "../../../../components/mui/table";
import { RENDERER_TYPES } from "../../../../enums";
import { InitialNameAvatar } from "../../../../components/images/initial-name-avatar";
import { MeetingStatus } from "../../../invitations/components/meeting-status";
import { convertToFullName } from "../../../../services/utils";
import { AppChip } from "../../../../components/chips";
import {
  DATE_FORMATS,
  formatDate,
} from "../../../../services/date-and-time.utils";

function ClientMeetingListTable({
  list,
  columns,
  handlePageFilters,
  appliedFilters,
}) {
  const { selectedPage, selectedPageSize } = appliedFilters;

  const handleTDRenderer = (row, column) => {
    switch (column.rendererType) {
      case RENDERER_TYPES.FULL_NAME_WITH_AVATAR:
        return (
          <InitialNameAvatar
            text={convertToFullName(
              row?.ambassador?.firstName,
              row?.ambassador?.lastName
            )}
            name={row?.ambassador?.firstName}
          />
        );
      case RENDERER_TYPES.CHIP_LIST:
        return (
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 0.5,
              maxWidth: "100%",
            }}
          >
            {row?.ambassador.topics
              ?.map((t) => t?.label)
              ?.map((item) => (
                <AppChip
                  key={item}
                  bgColor="#F2F3F8"
                  style={{
                    marginRight: 0,
                    marginBottom: 0,
                    height: "auto",
                    maxWidth: "100%",
                  }}
                  label={
                    <Box
                      component="span"
                      sx={{
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        display: "block",
                        py: 0.5,
                      }}
                    >
                      {item}
                    </Box>
                  }
                  fontColor={"#6C7293"}
                />
              ))}
          </Box>
        );
      case RENDERER_TYPES.FULL_DATE_FROM:
        return `${formatDate(
          row.selectedTimeSlot.from,
          DATE_FORMATS.fullDateWithTime
        )}`;
      case RENDERER_TYPES.MEETING_STATUS:
        return <MeetingStatus data={row} />;
      default:
        break;
    }
  };
  return (
    <SimpleTable
      tdRenderer={handleTDRenderer}
      rows={list?.data}
      columns={columns}
      fetching={list?.loading}
      total={list?.total}
      onPageSettingsChange={handlePageFilters}
      selectedPage={selectedPage}
      selectedPageSize={selectedPageSize}
    ></SimpleTable>
  );
}

export { ClientMeetingListTable };
